<ion-grid (click)="abrirNoticia();">
  <ion-row>
    <ion-col size="4" class="col-image">
      <div>
        <ion-img [src]="config.image | image:'evento'"></ion-img>
      </div>
    </ion-col>

    <ion-col size="6">
      <ion-item lines="none">
        <ion-label>
          <h2>{{config.title}}</h2>

          <span class="schedule-day" *ngIf="config.resume">
            {{config.resume}}
          </span>

          <p *ngIf="config.mostrar_data == '1'" class="schedule-day">{{config.date | dateFormat: 'ddmmyyyy'}}</p>
        </ion-label>
      </ion-item>
    </ion-col>

    <ion-col size="2" style="display: flex; justify-items: center; justify-content: center; align-items: center;">
      <i class="fas fa-chevron-right icon-list"></i>
    </ion-col>
  </ion-row>
</ion-grid>